import { IActionResponse, IActionResult, BaseClient, IPagedResult } from "../";
import { ApiParams, SearchDto } from "../../../assets/utils/lib";
import { DeviceQuestionnaireChoiceDto, FormDto, FormViewDto, LookupAnswerTypeDto, LookupQuestionTypeDto, QuestionnaireLookupsDto } from "../../dto";

export class QuestionnaireClient extends BaseClient {
    routes = ["questionnaire", "questionnaire"];

    async getQuestionnaireAsync(id: string | undefined): Promise<FormDto> {
        const actions: string[] = ["GetQuestionnaire"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: FormDto = await this.getAsync<FormDto>(actions, params);
        return result;
    }

    async getQuestionnaireResponseAsync(id: string | undefined): Promise<DeviceQuestionnaireChoiceDto[]> {
        const actions: string[] = ["GetQuestionnaireResponse"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: DeviceQuestionnaireChoiceDto[] = await this.getAsync<DeviceQuestionnaireChoiceDto[]>(actions, params);
        return result;
    }

    async getLookupsAsync(): Promise<QuestionnaireLookupsDto> {
        const actions: string[] = ["GetLookups"];
        const result = await this.getAsync<QuestionnaireLookupsDto>(actions, []);
        return result;
    }

    async deActivateQuestionnaireAsync(id: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeActivateQuestionnaire"];
        const params: ApiParams[] = [new ApiParams("communityid", id, true)];
        return await this.getAsync(actions, params);
    }

    async searchQuestionnairesAsync(payload: SearchDto | undefined): Promise<IPagedResult<FormViewDto>> {
        const actions: string[] = ["SearchQuestionnaire"];
        const result: IPagedResult<FormViewDto> = await this.postAsync<SearchDto, FormViewDto, IPagedResult<FormViewDto>>(actions, payload);
        return result;
    }

    async saveQuestionnaireAsync(payload: FormDto | undefined): Promise<IActionResult<FormDto>> {
        const actions: string[] = ["SaveQuestionnaire"];
        return await this.postAsync<FormDto>(actions, payload);
    }

    async deleteQuestionnaireAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteQuestionnaire"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];
        return await this.deleteAsync(actions, params);
    }

    async getLookupQuestionTypeAsync(id: string | undefined): Promise<LookupQuestionTypeDto> {
        const actions: string[] = ["GetLookupQuestionType"];
        const params: ApiParams[] = [new ApiParams("questionId", id, true)];

        const result: LookupQuestionTypeDto = await this.getAsync<LookupQuestionTypeDto>(actions, params);
        return result;
    }

    async getLookupQuestionTypesAsync(): Promise<LookupQuestionTypeDto[]> {
        const actions: string[] = ["GetAllLookupQuestionTypes"];
        return await this.getAsync<LookupQuestionTypeDto[]>(actions);
    }

    async searchLookupQuestionTypesAsync(searchDto: SearchDto): Promise<IPagedResult<LookupQuestionTypeDto>> {
        const actions: string[] = ["SearchLookupQuestionType"];
        const result: IPagedResult<LookupQuestionTypeDto> = await this.postAsync<SearchDto, LookupQuestionTypeDto, IPagedResult<LookupQuestionTypeDto>>(actions, searchDto);
        return result;
    }

    async saveLookupQuestionTypeAsync(payload?: LookupQuestionTypeDto | undefined): Promise<IActionResult<LookupQuestionTypeDto>> {
        const actions: string[] = ["SaveLookupQuestionType"];
        return await this.postAsync<LookupQuestionTypeDto>(actions, payload);
    }

    async deleteLookupQuestionTypeAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteLookupQuestionType"];
        const params: ApiParams[] = [
            new ApiParams("typeId", id, true)
        ];

        return await this.deleteAsync(actions, params);
    }

    async getLookupAnswerTypeAsync(id: string | undefined): Promise<LookupQuestionTypeDto> {
        const actions: string[] = ["GetLookupAnswerType"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];

        const result: LookupQuestionTypeDto = await this.getAsync<LookupQuestionTypeDto>(actions, params);
        return result;
    }

    async getLookupAnswerTypesAsync(): Promise<LookupAnswerTypeDto[]> {
        const actions: string[] = ["GetAllLookupAnswerTypes"];
        const result: LookupAnswerTypeDto[] = await this.getAsync<LookupQuestionTypeDto[]>(actions);
        return result;
    }

    async searchLookupAnswerTypesAsync(searchDto: SearchDto): Promise<IPagedResult<LookupAnswerTypeDto>> {
        const actions: string[] = ["SearchLookupAnswerType"];
        const result: IPagedResult<LookupAnswerTypeDto> = await this.postAsync<SearchDto, LookupAnswerTypeDto, IPagedResult<LookupAnswerTypeDto>>(actions, searchDto);
        return result;
    }

    async saveLookupAnswerTypeAsync(payload?: LookupAnswerTypeDto | undefined): Promise<IActionResult<LookupAnswerTypeDto>> {
        const actions: string[] = ["SaveLookupAnswerType"];
        return await this.postAsync<LookupAnswerTypeDto>(actions, payload);
    }

    async deleteLookupAnswerTypeAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteLookupAnswerType"];
        const params: ApiParams[] = [
            new ApiParams("typeId", id, true)
        ];

        return await this.deleteAsync(actions, params);
    }
}
